import { Service } from "@angular/core";

@Service()
export class DateHelperService {
  public today = new Date();

  constructor() {}

  public isToday(date: Date): boolean {
    const today = new Date();

    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  }

  public getStartOfYesterday(): Date {
    const today = new Date();
    today.setDate(today.getDate() - 1);
    today.setHours(0, 0, 0, 0);
    return today;
  }

  public getStartOfCurrentWeek(): Date {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    startOfWeek.setDate(today.getDate() + diff);
    startOfWeek.setHours(0, 0, 0, 0);
    return startOfWeek;
  }

  public getStartOfPreviousWeek(): Date {
    const startOfCurrentWeek = this.getStartOfCurrentWeek();
    const startOfPreviousWeek = new Date(startOfCurrentWeek);
    startOfPreviousWeek.setDate(startOfCurrentWeek.getDate() - 7);
    return startOfPreviousWeek;
  }

  public getStartOfCurrentMonth(): Date {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    startOfMonth.setHours(0, 0, 0, 0);
    return startOfMonth;
  }

  public getStartOfPreviousMonth(): Date {
    const startOfCurrentMonth = this.getStartOfCurrentMonth();
    const startOfPreviousMonth = new Date(startOfCurrentMonth);
    startOfPreviousMonth.setMonth(startOfCurrentMonth.getMonth() - 1);
    startOfPreviousMonth.setDate(1);
    startOfPreviousMonth.setHours(0, 0, 0, 0);
    return startOfPreviousMonth;
  }

  public isYesterday(date: Date): boolean {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    return date.getTime() === yesterday.getTime();
  }

  public isTodayOrYesterday(date: Date): boolean {
    return this.isToday(date) || this.isYesterday(date);
  }

  public isCurrentWeek(date: Date): boolean {
    const startOfCurrentWeek = this.getStartOfCurrentWeek();

    return date >= startOfCurrentWeek;
  }

  public isCurrentOrPreviousWeek(date: Date): boolean {
    const startOfPreviousWeek = this.getStartOfPreviousWeek();

    return date >= startOfPreviousWeek;
  }

  public isCurrentMonth(date: Date): boolean {
    const startOfCurrentMonth = this.getStartOfCurrentMonth();

    return date >= startOfCurrentMonth;
  }

  public isCurrentOrPreviousMonth(date: Date): boolean {
    const startOfPreviousMonth = this.getStartOfPreviousMonth();

    return date >= startOfPreviousMonth;
  }

  public getTwoWeeksAgo(): Date {
    const twoWeeksAgo = new Date(this.today);
    twoWeeksAgo.setDate(this.today.getDate() - 14);
    twoWeeksAgo.setHours(0, 0, 0, 0);
    return twoWeeksAgo;
  }

  public getDaysAgo(days: number): Date {
    const daysAgo = new Date(this.today);
    daysAgo.setDate(this.today.getDate() - days);
    daysAgo.setHours(0, 0, 0, 0);
    return daysAgo;
  }

  public toStartOfDay(date: Date): Date {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);
    return startOfDay;
  }

  public isInFuture(date: Date): boolean {
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);

    return compareDate > this.today;
  }
}
